<template>
  <div>
    <v-stepper-step
      :step="2"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(2)"
      :editable="(!isViewOredit && isStepCompleted(2)) || edit"
      edit-icon="$complete"
      :rules="[() => currentStep < 3 || !!templateData.name, () => !showNameError ]"

    >
      {{$t('commonWords.name')}}
      <small v-if="isStepCompleted(2) && currentStep !== 2" class="mt-2">{{ templateData.name }}</small>
    </v-stepper-step>
    <v-stepper-content :step="2">
      <v-text-field
        v-model="templateData.name"
        :label="$t('templates.name')"
        @input="validateIfNameIsUnique($event)"
        :error="showNameError"
        :error-messages="showNameError ? $t('campaign.duplicatedName') : ''"
        :rules="[() => !!templateData.name || $t('commonPhrases.requiredField') ]"
        required
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='nextStep()'
          :disabled="inputIsNull(templateData.name) || showNameError"
        >
          {{$t('commonWords.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()' v-if="method !== 'view' && !edit">
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="3"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(3)"
      :editable="(!isViewOredit && isStepCompleted(3)) || edit"
      :rules="[() => currentStep < 4 || !!templateData.text]"
      edit-icon="$complete"
    >
      {{$t('commonWords.message')}}
      <div v-if="isStepCompleted(3) && currentStep !== 3">
        <text-editor class='text-editor' :value="templateData.text" disabled theme="bubble" />
      </div>
    </v-stepper-step>
    <v-stepper-content :step="3">
      <text-editor
        @change="templateData.text = $event"
        :value="template.text"
        :label="$t('templateEditDialog.text')"
        :maxLength="1024"
        :disabled="method === 'view'"
        :showCounter="true"
        required
        isChannelTeams
        class="margin-bottom"
      />
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='nextStep()'
          :disabled="inputIsNull(templateData.text)"
        >
          {{$t('commonWords.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <v-stepper-step
      :step="4"
      :color='method === "view" ? "#9E9E9E" : "#43a047"'
      :complete="isStepCompleted(4)"
      :editable="(!isViewOredit && isStepCompleted(4)) || edit"
      edit-icon="$complete"
    >
      {{$t('templateEditDialog.button')}}
      <div v-if="isStepCompleted(4) && currentStep !== 4" class="mt-2 font-weight-regular">
        <p style="color: #757575">{{ showButtonGroupType }}</p>
        <p style='color: #ABB7C2' v-for="(button) in templateData.actionButtons" :key="button.id">
          {{ button.title }}; {{ button.payload }}
        </p>
      </div>
    </v-stepper-step>
    <v-stepper-content :step="4">
      <v-btn
        v-if="templateData.actionButtons.length <= 0"
        class="d-flex margin-bottom"
        color="#F19D38"
        style="gap: 13px; padding: 16px 12px"
        depressed
        @click="createNewButton"
      >
        <v-icon
          dark
        >
          mdi-plus
        </v-icon>
        <span>
          {{ $t('templateEditDialog.addNewQuickReply') }}
        </span>
      </v-btn>
      <v-row
        v-for="(button) in templateData.actionButtons"
        :key="button.id"
        class="ma-0 pa-0 d-flex"
        style="gap: 1rem;"
      >
        <v-col cols="auto" class="d-flex align-center" style="width: 100%; flex-wrap: nowrap; gap: 1rem; padding: 0">
          <v-text-field
            :label="$t('templateEditDialog.actionFieldLabels.buttonText')"
            v-model="button.title" filled
            required
            :rules="[() => !!button.title || $t('commonPhrases.requiredField')]"
            ></v-text-field>
          <v-text-field
            :label="$t('templateEditDialog.quickReplyPayload')"
            filled v-model="button.payload"
            required
            :rules="[() => !!button.payload || $t('commonPhrases.requiredField')]"
          />
          <div style="height: 56% !important; align-self: flex-start; display: flex !important; align-items: flex-end !important;">
            <v-btn
              @click="deleteActionButton(button.id)"
              depressed
              fab
              dark
              color="#f44336"
              x-small
            >
              <v-icon dark>delete</v-icon>
              <md-tooltip md-direction="bottom">
                Remover
              </md-tooltip>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-btn
        v-if="templateData.actionButtons.length > 0"
        class="d-flex margin-bottom"
        style="gap: 13px; padding: 16px 12px; border: 1px; border-style: dashed;"
        depressed
        color="#F19D38"
        plain
        @click="createNewButton"
      >
        <v-icon
          dark
        >
          mdi-plus
        </v-icon>
        <span>
          {{ $t('templateEditDialog.addNewQuickReply') }}
        </span>
      </v-btn>
      <div class="d-flex margin-bottom" style='gap: 1rem;'>
        <v-btn
          color='#43a047'
          style='color: white;'
          @click='completeStep()'
        >
          {{$t('commonWords.continue')}}
        </v-btn>
        <v-btn text @click='prevStep()'>
          {{$t('commonWords.back')}}
        </v-btn>
      </div>
    </v-stepper-content>
    <div class="v-card-actions text-right" style="margin-right: 20px" v-if="(stepperCompleted || edit) && method !== 'view'">
      <v-btn text style="margin-right: 10px" @click="$emit('close')">{{ $t('commonWords.cancel') }}</v-btn>
      <v-btn
        color="#43a047"
        style="color: white;"
        :loading="loading"
        :disabled="loading"
        @click="$emit('createTemplate', templateData)"
      >
      {{ saveOrCreateButtonText }}</v-btn>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import TextEditor from '@/components/TextEditor.vue'
import debounce from 'lodash.debounce'

export default {
  name: 'TeamsSteps',
  components: {
    TextEditor
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: Number
    },
    stepperCompleted: {
      type: Boolean,
      default: false
    },
    method: {
      type: String
    },
    isViewOredit: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showNameError: false,
      templateData: {
        name: null,
        text: null,
        actionButtons: []
      }
    }
  },
  created () {
    if (this.template) {
      this.templateData = {
        name: this.template.name,
        text: this.template.text,
        actionButtons: this.template.buttons
      }
    }
  },
  computed: {
    saveOrCreateButtonText () {
      return this.edit ? this.$t('commonWords.save') : this.$t('commonWords.create')
    },
    showButtonGroupType () {
      if (!this.templateData.actionButtons.length) {
        return this.$t('templateEditDialog.radioButtonTitles.noButton')
      }
      return `${this.$t('templateEditDialog.selectedOptions')}; ${this.$t('templateEditDialog.quickReplyPayload')}`
    }
  },
  methods: {
    inputIsNull (inputValue) {
      return inputValue === null || String(inputValue).trim() === ''
    },
    nextStep () {
      this.$emit('nextStep')
    },
    prevStep () {
      this.$emit('prevStep')
    },
    completeStep () {
      this.$emit('completeStep')
    },
    isStepCompleted (step) {
      if (this.edit) {
        return true
      }
      return step < this.currentStep
    },
    createNewButton () {
      const buttonStructure = {
        id: uuidv4(),
        title: null,
        payload: null
      }

      this.templateData.actionButtons.push(buttonStructure)
    },
    deleteActionButton (id) {
      this.templateData.actionButtons = this.templateData.actionButtons.filter((button) => button.id !== id)
    },
    validateIfNameIsUnique: debounce(async function () {
      try {
        await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/validation-name`, {
          params: {
            name: this.templateData.name.trim()
          }
        })
        this.showNameError = false
      } catch (e) {
        this.showNameError = true
      }
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
  .margin-bottom {
    margin-bottom: 1rem;
  }
  .text-editor {
    margin-top: 5px;
    & ::v-deep .quill-editor .ql-container {
      color: rgba(0,0,0,.6);
      background-color: transparent !important;
      border: 0 !important;
      & .ql-editor {
        padding: 0 !important;
      }
    }
  }
</style>
